<template>
  <RouterView />
</template>

<script setup lang="ts">
import { removeAll } from 'common/utils/cookies'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { RouterView } from 'vue-router'

// 监听UA变化
const originalUA = navigator.userAgent

const lastWidth = window.innerWidth

// 监听窗口大小以及UA变化
const handleResize = () => {
  const { innerWidth, innerHeight } = window
  // 仅判断宽度变化，窗口宽度小于768或者UA变化时，重新加载页面
  if (
    (innerWidth !== lastWidth && lastWidth >= 768) ||
    navigator.userAgent !== originalUA
  ) {
    window.location.reload()
  }
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  removeAll()
})
</script>

<style lang="scss" scoped></style>
